import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { message } from '../../../../Message';
import { useRefFunction, useToggle } from '@tencent/glue-react-use';
import { useMemo, useRef, useState } from 'react';
import { API_TIMEOUT_ERROR_MSG, API_TIME_OUT, SERVER_ERROR_MSG } from '../../common/const';
import { transImageUploadValue } from '../../MaterialUpload/util/util';
export var useImageList = function useImageList(props) {
  var _props$pageSize = props.pageSize,
    pageSize = _props$pageSize === void 0 ? 15 : _props$pageSize,
    uid = props.uid,
    scope = props.scope,
    request = props.request,
    url = props.url;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    imgList = _useState2[0],
    setImgList = _useState2[1];
  var cancelRef = useRef(null);
  var _useToggle = useToggle(false),
    _useToggle2 = _slicedToArray(_useToggle, 3),
    isLoading = _useToggle2[0],
    showLoading = _useToggle2[1],
    hideLoading = _useToggle2[2];
  var _useState3 = useState({
      total: 0,
      pageIndex: 1
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    pageInfo = _useState4[0],
    setPageInfo = _useState4[1];
  var abort = function abort() {
    var _a;
    (_a = cancelRef.current) === null || _a === void 0 ? void 0 : _a.call(cancelRef);
  };
  var reset = function reset() {
    setImgList([]);
  };
  var imgMap = useMemo(function () {
    return imgList.reduce(function (obj, item) {
      obj[item.materialId] = item;
      return obj;
    }, {});
  }, [imgList]);
  var requestImageList = useRefFunction(function (ops) {
    showLoading();
    var _ops$pageIndex = ops.pageIndex,
      pageIndex = _ops$pageIndex === void 0 ? 1 : _ops$pageIndex,
      _ops$description = ops.description,
      description = _ops$description === void 0 ? '' : _ops$description;
    return request.post(url, {
      uid: uid,
      page_no: pageIndex,
      page_size: pageSize,
      scope: scope,
      description: description
    }, {
      cancelToken: new request.CancelToken(function (cancel) {
        return cancelRef.current = cancel;
      }),
      timeout: API_TIME_OUT,
      timeoutErrorMessage: API_TIMEOUT_ERROR_MSG,
      withCredentials: true
    }).then(function (_ref) {
      var code = _ref.code,
        data = _ref.data;
      if (code === 0) {
        return data;
      }
      message.error(SERVER_ERROR_MSG);
    }).catch(function (err) {
      var _a;
      if ((_a = request.isCancel) === null || _a === void 0 ? void 0 : _a.call(request, err)) {
        return;
      }
      message.error(SERVER_ERROR_MSG);
    }).finally(function () {
      hideLoading();
    });
  });
  var getList = useRefFunction(function (ops) {
    var pageIndex = ops.pageIndex,
      description = ops.description,
      _ops$mergeCurrentList = ops.mergeCurrentList,
      mergeCurrentList = _ops$mergeCurrentList === void 0 ? false : _ops$mergeCurrentList;
    return requestImageList({
      pageIndex: pageIndex,
      description: description
    }).then(function (res) {
      var _a;
      if (res) {
        var list = res.list,
          totalNum = res.range.total_num;
        setPageInfo({
          pageIndex: (_a = ops.pageIndex) !== null && _a !== void 0 ? _a : 1,
          total: totalNum
        });
        var newList = list.map(transImageUploadValue);
        setImgList(mergeCurrentList ? mergeList(newList) : newList);
        return;
      }
      setImgList(mergeCurrentList ? mergeList([]) : []);
    });
  });
  var mergeList = function mergeList(newList) {
    return imgList.concat(newList);
  };
  return {
    imgList: imgList,
    imgMap: imgMap,
    pageInfo: pageInfo,
    getList: getList,
    isLoading: isLoading,
    abort: abort,
    reset: reset
  };
};